import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Script } from "./Script";
import { CITIES } from "../mock";

// Exactly Teya's city cycler: vertical slot-machine slide inside an
// overflow-hidden window with a soft top/bottom gradient mask.
const MASK = "linear-gradient(to bottom, transparent 0%, black 22%, black 78%, transparent 100%)";
const STEP_MS = 2000;
const EASE = "transform 600ms cubic-bezier(0.25, 0.1, 0.25, 1)";

const CityCycler = () => {
  const n = CITIES.length;
  const list = [...CITIES, CITIES[0]];
  const [i, setI] = useState(0);
  const [snap, setSnap] = useState(false);

  useEffect(() => {
    if (snap) {
      const r = requestAnimationFrame(() => setSnap(false));
      return () => cancelAnimationFrame(r);
    }
    if (i === n) {
      const t = setTimeout(() => {
        setSnap(true);
        setI(0);
      }, 620);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => setI(i + 1), STEP_MS);
    return () => clearTimeout(t);
  }, [i, snap, n]);

  return (
    <span className="flex justify-center tracking-normal" data-testid="cta-city-slot">
      <span
        className="relative block h-[1.4em] w-fit overflow-hidden text-center"
        style={{ maskImage: MASK, WebkitMaskImage: MASK }}
      >
        <span
          className="block"
          style={{
            willChange: "transform",
            transition: snap ? "none" : EASE,
            transform: `translateY(-${i * 1.4}em)`,
          }}
        >
          {list.map((city, idx) => (
            <span
              key={`${city}-${idx}`}
              className="flex h-[1.4em] items-center justify-center whitespace-nowrap serif"
              style={{ fontWeight: 500 }}
              data-testid={idx === i ? "cta-city" : undefined}
            >
              {city}
            </span>
          ))}
        </span>
      </span>
    </span>
  );
};

export default function CtaBanner() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative overflow-hidden bg-[#050504]" data-testid="cta-banner">
      <div className="container-x relative py-28 md:py-40 text-center">
        <h2 className="reveal text-white" data-testid="cta-headline">
          <span className="block serif text-[7vw] sm:text-4xl lg:text-5xl" style={{ fontWeight: 400 }}>
            Vybírají si nás
          </span>

          <span className="block mt-2 md:mt-3 whitespace-nowrap">
            <Script variant="double" color="#d8ff00" width={5.5} className="text-[11vw] sm:text-6xl lg:text-7xl">
              místní firmy
            </Script>
            <span className="serif text-[7vw] sm:text-4xl lg:text-5xl ml-5 md:ml-12" style={{ fontWeight: 400 }}>
              z
            </span>
          </span>

          <span className="block mt-1 md:mt-3 text-[7.5vw] sm:text-5xl lg:text-6xl">
            <CityCycler />
          </span>

          <span className="block mt-1 md:mt-3 serif text-[7vw] sm:text-4xl lg:text-5xl" style={{ fontWeight: 400 }}>
            které chtějí být vidět.
          </span>
        </h2>

        <p className="reveal text-white/70 mt-12 max-w-xl mx-auto text-base md:text-lg">
          Návrh a orientační cenu dostanete do 24 hodin. Bez závazků, bez dlouhých smluv a bez vstupních poplatků.
        </p>

        <div className="reveal mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button onClick={() => go("#kontakt")} data-testid="cta-banner-primary" className="btn-lime px-8 py-4">
            Chci nový web <ArrowRight size={18} />
          </button>
          <button onClick={() => go("#cenik")} data-testid="cta-banner-secondary" className="btn-outline-light px-8 py-4">
            Zobrazit ceník
          </button>
        </div>
      </div>
    </section>
  );
}
